<script setup lang="ts">
// Behavioural port of AI SDK Elements' `SourcesTrigger` (Apache-2.0, Copyright Vercel); anatomy only.

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { AltArrowDownIcon } from '@solar-icons/vue/linear'
import AppCarvedRail from '../../primitives/AppCarvedRail/AppCarvedRail.vue'
import AppCarvedRailChip from '../../primitives/AppCarvedRail/AppCarvedRailChip.vue'
import AppFavicon from '../../primitives/AppFavicon/AppFavicon.vue'
import { sourceChipName, type SourceEntry } from './source-types'

const props = defineProps<{
  sources: SourceEntry[]
  open: boolean
  triggerAttrs?: Record<string, unknown>
}>()

defineEmits<{
  toggle: []
}>()

const { t } = useI18n()

const CHIP_LIMIT = 4

const chips = computed(() => props.sources.slice(0, CHIP_LIMIT))
const hidden = computed(() => Math.max(0, props.sources.length - CHIP_LIMIT))
</script>

<template>
  <AppCarvedRail as="button" v-bind="triggerAttrs" class="self-start" @click="$emit('toggle')">
    <span class="sr-only">{{ t('chat.sources.count', sources.length) }}</span>
    <AppCarvedRailChip v-for="source in chips" :key="source.ref" aria-hidden="true">
      <AppFavicon :src="source.favicon" :kind="source.kind" />
      <span class="truncate">{{ sourceChipName(source) }}</span>
    </AppCarvedRailChip>
    <span class="icon-sm flex shrink-0 items-center gap-1 pr-2 pl-1" aria-hidden="true">
      <span v-if="hidden" class="tabular-nums">+{{ hidden }}</span>
      <AltArrowDownIcon
        class="transition-transform duration-fast ease-soft motion-reduce:transition-none"
        :class="open && 'rotate-180'"
      />
    </span>
  </AppCarvedRail>
</template>
